import { useEffect } from 'react';

/**
 * Hook that adds antd-scope class to body element
 * This ensures that Ant Design components that render outside the normal DOM hierarchy
 * (like modals, dropdowns, tooltips) still get the proper styling
 */
export const useAntdScope = (): void => {
  useEffect(() => {
    // Add antd-scope to body
    document.body.classList.add('antd-scope');
    // Cleanup: remove antd-scope from body when component unmounts
    return () => {
      document.body.classList.remove('antd-scope');
    };
  }, []);
};
